import { render, staticRenderFns } from "./CalendarImport.vue?vue&type=template&id=49135538&scoped=true"
import script from "./CalendarImport.vue?vue&type=script&lang=js"
export * from "./CalendarImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49135538",
  null
  
)

export default component.exports